import { keyPairReady, getPublicKeyBase64 } from '../crypto/e2e';

export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  await keyPairReady;
  const headers = new Headers(options.headers as HeadersInit);
  headers.set('X-Public-Key', getPublicKeyBase64()!);
  return fetch(url, { ...options, headers });
}
